import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  addLinkItemToSupplier,
  getItemsToLink,
  getLinkedSupplier,
} from "../../services/linkItemToSupplierService";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

const LinkItemToSupplierModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { handleSubmit, setValue } = useForm();

  const items = useSelector((state) => state.linkItemToSupplier);

  useEffect(() => {
    dispatch(getItemsToLink());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.suppliers.add_item")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.ItemsSuppliers = values.ItemsSuppliers?.map((el) => ({
                InventoryItemId: el.InventoryItemId,
                SuppliersId: id.suppliersId,
              }));
              values.ItemsSuppliersId = null;
              values.UserId = localStorage.getItem("userId");
              if (
                values.ItemsSuppliers === undefined ||
                values.ItemsSuppliers?.length === 0
              ) {
                toast2({ description: t("validation.choose_first") });
              } else {
                dispatch(addLinkItemToSupplier(values))
                  .unwrap()
                  .then((_) => {
                    toast({ description: t("pages.suppliers.item_linked") });
                    dispatch(getLinkedSupplier(id.suppliersId));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.inventory.item")}
                data={
                  Array.isArray(items.data)
                    ? items.data.map((el) => ({
                        ...el,
                        label: el.InventoryItemNameEng,
                        value: el.InventoryItemId,
                      }))
                    : []
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("ItemsSuppliers", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={items.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={items.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default LinkItemToSupplierModal;
